var _defs, _path, _polyline, _polyline2, _line, _path2, _polyline3, _polyline4, _polyline5, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maze-strategy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5,3.729H21a1.5,1.5,0,0,1,1.5,1.5v16.5a1.5,1.5,0,0,1-1.5,1.5H13.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "10.5 23.229 10.5 17.229 7.5 17.229 7.5 12.729 10.5 12.729 10.5 6.729 13.5 6.729 13.5 0.729"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "10.5 3.697 13.5 0.729 16.5 3.697"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 15.729,
    x2: 15,
    y2: 20.229
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.75,3.729H3a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5H7.5v-3h-3v-2.25"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "18 23.229 18 14.229 19.5 14.229"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "22.5 11.229 15 11.229 15 12.729"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "4.5 7.479 4.5 9.729 6.75 9.729"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 18,
    y1: 11.229,
    x2: 18,
    y2: 8.229
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActIcon);
export default __webpack_public_path__ + "static/media/Act_Icon.0fed2894fbe18de47348b54f69b16592.svg";
export { ForwardRef as ReactComponent };